import { type NodeData, isPathLookupNodeData } from '@ipfabric/utils';
import {
  type GraphMetadata,
  isPathLookupGraphMetadata,
} from 'components/Graph/GraphState';

export const hasNodePathInspectorDetail = (
  nodeData: NodeData,
  graphMetadata: GraphMetadata | null,
): boolean =>
  isPathLookupNodeData(nodeData) &&
  isPathLookupGraphMetadata(graphMetadata) &&
  graphMetadata.decisions[nodeData.id] !== undefined;
